import React from 'react'
import CarImg from "../assets/illustrations/servi_car2_bg.png"
import Taxido from "../assets/illustrations/TaxiDo.png"

function AboutArea() {
  return (
    <div className="about-area py-120">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    <div className="about-left wow fadeInLeft" data-wow-delay=".25s">
                        <div className="about-img">
                            <img src={CarImg} alt="About ServiSwift" />
                        </div>
                        <div className="about-experience">
                            <div className="about-experience-icon">
                                <img src={Taxido} alt="ServiSwift Icon" />
                            </div>
                            <b>Delivering Excellence <br /> Across Malawi</b>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="about-right wow fadeInRight" data-wow-delay=".25s">
                        <div className="site-heading mb-3">
                            <span className="site-title-tagline justify-content-start">
                                <i className="flaticon-drive"></i> About Us
                            </span>
                            <h2 className="site-title">
                                Trusted for your <span>Everyday Needs</span>
                            </h2>
                        </div>
                        <p className="about-text">
                            At ServiSwift, we are committed to making life easier for individuals and businesses. 
                            With a focus on reliability, innovation, and customer satisfaction, we provide services that meet diverse everyday needs.
                        </p>
                        <div className="about-list-wrapper">
                            <ul className="list-unstyled">
                                <li>
                                    <i className='pi pi-arrow-right'></i> <strong>TaxiDo:</strong> Safe and reliable ride-hailing services.
                                </li>
                                <li>
                                    <i className='pi pi-arrow-right'></i> <strong>FixSwift:</strong> connects you to a pool of top notch skilled artisans.
                                </li>
                                <li>
                                    <i className='pi pi-arrow-right'></i> <strong>DropSwift:</strong> Efficient delivery services for your items.
                                </li>
                                <li>
                                    <i className='pi pi-arrow-right'></i> <strong>ShopSwift:</strong> A seamless platform for online shopping in Malawi.
                                </li>
                            </ul>
                        </div>
                        <a href="about.html" className="theme-btn mt-4">Discover More<i className="fas fa-arrow-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AboutArea